import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  WABaseScreenParams,
  WACategoryNavigationProp,
} from "../../WANavigation";

type ParamList = {
  WACategoryTodoCategoriesSelectCategory: WABaseScreenParams;
  WACategoryTodoCategoriesSelectType: WABaseScreenParams & {
    categoryId: string;
  };
};
export const WACategoryTodoCategoriesNavigator =
  createNativeStackNavigator<ParamList>();

export type WACategoryTodoCategoriesScreenProps<T extends keyof ParamList> = {
  route: RouteProp<ParamList, T>;
  navigation: CompositeNavigationProp<
    WACategoryNavigationProp<"WACategoryTodoCategories">,
    NativeStackNavigationProp<ParamList, T>
  >;
};
